import types from './types'

const updateSavedSearch = (query, nameSearch) => (dispatch) => {
  dispatch({
    type: types.UPDATE_SAVED_SEARCH,
    payload: {
      query,
      nameSearch,
    },
  })
}

export default {
  updateSavedSearch,
}
